module.exports = __webpack_public_path__ + "img/redis.fb427422.svg";